module.exports = __webpack_public_path__ + "img/placeholder.1768af80.png";